import { render, staticRenderFns } from "./FasapayFailed.vue?vue&type=template&id=f90267b8&"
import script from "./FasapayFailed.vue?vue&type=script&lang=js&"
export * from "./FasapayFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports